export default function classNames(
    ...args: (string | null | undefined)[]
  ): string {
    const arr = Array.isArray(args[0]) ? [...args[0]] : args;
    return arr.filter((f) => f).join(' ');
  }
  